var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLeft = function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.50147,
    height: 7.06617,
    transform: "matrix(0.70848 0.705731 -0.70848 0.705731 5.92383 0)",
    fill: "#2F2F4B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.50292,
    height: 7.08796,
    transform: "matrix(-0.70848 0.705731 -0.70848 -0.705731 7 8.92188)",
    fill: "#2F2F4B"
  })));
};
export default SvgIconArrowLeft;